import { createContext } from 'react';

interface AuthContextType {
  isAuthenticated: boolean;
  accessToken: string | null;
  role: string | null;
  login: (token: string, role: string) => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType | null>(null);
